// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoSectionErrorText_container__qcRWx","subContainer":"InfoSectionErrorText_subContainer__hjDrY"};